/**
 * Ingredient pairing checker. Per content/pairing-checker.md.
 *
 * Everything this script touches is already in the HTML: the grid, all
 * twenty-eight pair panels and their verdicts are server rendered. The script
 * only adds a way to narrow the page to one pair, so a reader without
 * JavaScript loses the shortcut and keeps the answers.
 */
(function () {
  var root = document.querySelector('[data-pairing]');
  if (!root) return;

  var picker = root.querySelector('[data-pairing-picker]');
  var selectA = root.querySelector('[data-pairing-a]');
  var selectB = root.querySelector('[data-pairing-b]');
  var note = root.querySelector('[data-pairing-note]');
  var reset = root.querySelector('[data-pairing-reset]');
  var empty = root.querySelector('[data-pairing-empty]');
  var panels = [].slice.call(root.querySelectorAll('[data-pairing-pair]'));

  if (!picker || !selectA || !selectB || !panels.length) return;

  picker.hidden = false;

  function track(event, detail) {
    if (!window.dataLayer) return;
    var payload = { event: event };
    for (var key in detail) {
      if (Object.prototype.hasOwnProperty.call(detail, key)) payload[key] = detail[key];
    }
    window.dataLayer.push(payload);
  }

  function matches(panel, a, b) {
    var pa = panel.getAttribute('data-a');
    var pb = panel.getAttribute('data-b');
    return (pa === a && pb === b) || (pa === b && pb === a);
  }

  function showAll() {
    panels.forEach(function (panel) {
      panel.hidden = false;
    });
    if (empty) empty.hidden = true;
    if (reset) reset.hidden = true;
    if (note) note.textContent = '';
  }

  function filterTo(a, b, shouldScroll) {
    if (!a || !b) {
      showAll();
      return;
    }

    if (a === b) {
      showAll();
      if (note) note.textContent = root.getAttribute('data-label-same') || '';
      return;
    }

    var found = null;
    panels.forEach(function (panel) {
      var hit = matches(panel, a, b);
      panel.hidden = !hit;
      if (hit) found = panel;
    });

    if (empty) empty.hidden = !!found;
    if (reset) reset.hidden = false;
    if (note) note.textContent = '';

    if (found && shouldScroll) {
      found.scrollIntoView({
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches
          ? 'auto'
          : 'smooth',
        block: 'start'
      });
    }

    track('pairing_check', {
      pairing_a: a,
      pairing_b: b,
      pairing_verdict: found ? found.className.replace(/.*pairing__pair--(\w+).*/, '$1') : 'none'
    });
  }

  function onChange() {
    filterTo(selectA.value, selectB.value, true);
  }

  selectA.addEventListener('change', onChange);
  selectB.addEventListener('change', onChange);

  if (reset) {
    reset.addEventListener('click', function () {
      selectA.value = '';
      selectB.value = '';
      showAll();
      picker.scrollIntoView({
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches
          ? 'auto'
          : 'smooth',
        block: 'start'
      });
    });
  }

  // A tap on the grid sets the dropdowns as well as jumping, so the picker
  // always reflects what the reader is looking at.
  root.addEventListener('click', function (event) {
    var link = event.target.closest ? event.target.closest('[data-pairing-jump]') : null;
    if (!link) return;
    var parts = link.getAttribute('data-pairing-jump').split('--');
    if (parts.length !== 2) return;
    event.preventDefault();
    selectA.value = parts[0];
    selectB.value = parts[1];
    filterTo(parts[0], parts[1], true);
  });

  // A shared link such as #pair-niacinamide--retinol should open on that pair.
  var hash = window.location.hash;
  if (hash.indexOf('#pair-') === 0) {
    var pair = hash.slice(6).split('--');
    if (pair.length === 2) {
      selectA.value = pair[0];
      selectB.value = pair[1];
      filterTo(pair[0], pair[1], false);
    }
  }
})();
